/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoAssignRegistries } from '../../models/dto-assign-registries';

export interface IdentityControllerAssignRegistry$Params {
      body: DtoAssignRegistries
}

export function identityControllerAssignRegistry(http: HttpClient, rootUrl: string, params: IdentityControllerAssignRegistry$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse>> {
  const rb = new RequestBuilder(rootUrl, identityControllerAssignRegistry.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse>;
    })
  );
}

identityControllerAssignRegistry.PATH = '/identity/registry';
